export const PATH =
  process.env.REACT_APP_ELECTION_PATH ||
  "https://elecciones.atresmedia.com/cmselections/"; // IP de Juan  prek8scms.atresmedia.com // 10.1.1.85:8080  // pro https://elecciones.atresmedia.com/cmselections/

export const ELECTION_SPAIN_GENERAL_EUROPE = "C108";

export const CODE_CANARY = "R05";

export const PLACE_ID =
  process.env.REACT_APP_PLACE_ID || ELECTION_SPAIN_GENERAL_EUROPE;

export const TYPES = {
  GENERAL: "GENERAL",
  REGIONAL: "REGIONAL",
  MUNICIPAL: "MUNICIPAL",
  EUROPEAN: "EUROPEAN"
};

export const SUBTYPES = {
  CONGRESS: "CONGRESS",
  SENATE: "SENATE",
  SINGLE: "SINGLE",
  INSULAR: "INSULAR",
  REGIONAL: "REGIONAL"
};

export const EXCLUDED_REGIONS = [
  "R10",
  "R12",
  "R16",
  "R09",
  "R01",
  "R18",
  "R19"
];

window.__debug__ = process.env.REACT_APP_DEBUG || false;
